export default __webpack_public_path__ + "static/media/Versailles.318453f1.jpg";